import { useState, useEffect } from "react";

// Converte una planimetria raster (linee scure su carta chiara) in un layer colorato trasparente
export const useTintedImage = (srcUrl, [r, g, b]) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!srcUrl) { setUrl(null); return; }
    let active = true;
    const img = new Image();
    img.onload = () => {
      if (!active) return;
      const scale = Math.min(1, 1600 / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, c.width, c.height);
      const d = ctx.getImageData(0, 0, c.width, c.height);
      const px = d.data;
      for (let i = 0; i < px.length; i += 4) {
        const lum = (px[i] * 0.299 + px[i + 1] * 0.587 + px[i + 2] * 0.114) * (px[i + 3] / 255) + (255 - px[i + 3]);
        px[i] = r; px[i + 1] = g; px[i + 2] = b;
        px[i + 3] = 255 - lum;
      }
      ctx.putImageData(d, 0, 0);
      setUrl(c.toDataURL("image/png"));
    };
    img.onerror = () => active && setUrl(null);
    img.src = srcUrl;
    return () => { active = false; };
  }, [srcUrl, r, g, b]);
  return url;
};
